require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./iure-et-dolor-rerum-consequatur.json") })
        }
      }, "path---iure-et-dolor-rerum-consequatur");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---iure-et-dolor-rerum-consequatur!./.cache/json/iure-et-dolor-rerum-consequatur.json
// module id = 398
// module chunks = 231608221292675